// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* STYLES FOR ALL TABLES */
.side_table_wrapper {
    width: 100%;
    max-width: 68vw;
}
.table_box {
    width: 100%;
}

.planlist th{
	padding-left: 1.3%
}

.table_wrapper {
    width: 100%;
    min-height: 100%;
}

.table_wrapper-overview{
    width: 100%;
    min-height: 100%;
}
.table_wrapper-overview th {
    text-align: left;
    padding-left: 1.3%;
    height: 75px;
    background-color: #DFDFEA;
    font-size: 12px;
    font-weight: 600;
    color: #222222;
}

.table_wrapper.overview th:first-child {
    border-radius: 5px 0 0 5px;
}


.table_wrapper th {
    text-align: left;
    height: 75px;
    padding-left: 1.3%;
    background-color: #DFDFEA;
    font-size: 12px;
    font-weight: 600;
    color: #222222;
}

@media (max-width:450px){
    .table_wrapper th {
        text-align: left;
        height: 75px;
        padding-left: 3px;
        background-color: #DFDFEA;
        font-size: 12px;
        font-weight: 600;
        color: #222222;
    }
}

th {
    text-align: left;
    padding: 0;
    font-size: 12px;
    background-color: #DFDFEA;
    height: 76px;
}

.table_wrapper th:first-child {
    border-radius: 5px 0 0 5px;
}
.table_wrapper th:last-child {
    border-radius: 0 5px 5px 0;
}
.spacer {
    height: 4px;
}
.table-item {
    height: 74px;
    background-color: #ffffff;
}

.dirty {
    background-color: #F5C6CB;
}

.blocked_item {
    height: 74px;
    background-color: #EEEEF3;
}

.blocked_item > td {
    color: #989898;
}

.permission_row {
    border-bottom: 1px solid rgba(12,32,53,0.1);
}

.list-triangle {
    position: relative;
    z-index: 0;
    font-size: 22px;
    cursor: pointer;
    margin-left: 10px;
    color: #C3C4D1;
}
.list-triangle.top {
    transform: rotateZ(-180deg) translateY(-10px);
}
.list-triangle.bottom {
    transform: translateY(-10px);
}
.list-triangle.selected {
    color: #000435;
}
/* PAGE TABLES FOR EMPLOYEES */
table.page-table td {
    padding-left: 0px;
}
table.page-table tr td:first-child {
    padding-left: 10px;
}

table.perm_table tr td {
    border: solid 1px #F3F3F3;
    border-style: none none solid none;
    font-weight: 500;
    color: #000000;
    font-size: 12px;
}


/* ONLY ONE WAY TO DO BORDER-RADIUS */
table { border-collapse: separate; border-spacing: 0; }
td {
    border: solid 1px #F3F3F3;
    border-style: none solid solid none;
    padding-left: 1.3%;
    font-weight: 500;
    color: #000000;
    font-size: 12px;
}

.selected_row {
    border: solid 1px rgba(116, 116, 147, 0.22);
    border-style: none solid solid none;
    border-top-style: solid;
    padding-left: 25px;
    font-weight: 500;
    color: #000000;
    font-size: 12px;
    height: 74px;
    background-color: rgba(118, 116, 147, 0.22);
}


tr td:first-child { border-bottom-left-radius: 5px; }
tr td:last-child { border-bottom-right-radius: 5px; }
tr td { border-top-style: solid; }
tr td:first-child { border-left-style: solid; }
tr td:not(:last-child) {border-right-style: hidden;}

/* Employee without App STYLES */
.employee_dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
}

td a {
    text-decoration: none;
    color: black;
}

.employee_table {
    width: 100%;
}
@media (max-width: 700px) {
    .employee_table {
        table-layout: fixed;
    }
}
/* Pending orders STYLES */
.action_dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #A2ADBF;
}
.action_container {
    cursor: pointer;
    max-width: 30px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    position: relative;
}
.action_dots_container {
    position: relative;
}
.table_menu {
    position: absolute;
    min-width: 180px;
    min-height: 30px;
    background-color: white;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    right: 20px;
    top: 15px;
    z-index: 10!important;
}
.table_menu_item {
    height: 3rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 10px;
}
.table_menu_item > p {
    padding-left: 7px;
    font-size: 12px;
    font-weight: 600;
    color: #4B5960;
}
.table_menu_item > img {
    width: 17px;
    height: 17px;
}
.table_menu_item:not(:last-child) {
    border-bottom: 1px solid rgba(112,112,112 ,0.1);
}

.table-status {
    margin-top: 26px;
    color: #747578;
    font-size: 14px;
}

.notifications_list_item {
    width: 100%;
    height: 60px;
    border-radius: 3px;
    background-color: white;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    min-width: 400px;
}

.unread_notification_dot {
    width: 10px;
    height: 10px;
    min-width: 10px;
    min-height: 10px;
    border-radius: 50%;
    background-color: red;
    margin-right: 10px;
}

.notification_item_image_box {
    position: relative;
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.notification_item_image_box > img {
    width: 80px;
    margin-bottom: -10px;
}

.notification_item_name {
    font-size: 14px;
    padding-left: 10px;
    font-weight: 600;
    color: #1EC0A6;
}

.notification_item_text {
    padding-left: 10px;
    font-size: 12px;
}

.notification_item_date {
    font-size: 12px;
    color: #1EC0A6;
}

.notification_item_link {
    width: 15px;
    margin-left: 15px;
    cursor: pointer;
    transition: 0.2s;
}

.notification_item_link:hover {
    filter: sepia(100%) hue-rotate(190deg) saturate(500%) brightness(50%);
}

.billing_button {
    padding: 3px 7px;
    border: 1px solid #fd552b;
    color: #fd552b;
    border-radius: 5px;
    font-size: 10px;
}

.billing_list_btn {
    border: 1px solid #fd552b;
    color: #fd552b;
    padding: 5px 10px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
}

@media (max-width: 1400px) {
    .table_box {
        width: 100%;
        max-width: 86vw;
        overflow-x: auto;
    }
    .responsive-mr-40 {
        margin-right: 40px;
    }
    .notification_item_name {
        font-size: 12px;
        padding-left: 7px;
    }
    .notification_item_text {
        padding-left: 7px;
        font-size: 10px;
    }
    .notification_item_date {
        font-size: 10px;
        padding-left: 7px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/Components/Lists/ListStyles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;AACf;;AAEA;CACC;AACD;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,6CAA6C;AACjD;AACA;IACI,4BAA4B;AAChC;AACA;IACI,cAAc;AAClB;AACA,8BAA8B;AAC9B;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;;AAGA,qCAAqC;AACrC,QAAQ,yBAAyB,EAAE,iBAAiB,EAAE;AACtD;IACI,yBAAyB;IACzB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,mCAAmC;IACnC,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,2CAA2C;AAC/C;;;AAGA,oBAAoB,8BAA8B,EAAE;AACpD,mBAAmB,+BAA+B,EAAE;AACpD,QAAQ,uBAAuB,EAAE;AACjC,oBAAoB,wBAAwB,EAAE;AAC9C,wBAAwB,0BAA0B,CAAC;;AAEnD,gCAAgC;AAChC;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA,0BAA0B;AAC1B;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":["/* STYLES FOR ALL TABLES */\n.side_table_wrapper {\n    width: 100%;\n    max-width: 68vw;\n}\n.table_box {\n    width: 100%;\n}\n\n.planlist th{\n\tpadding-left: 1.3%\n}\n\n.table_wrapper {\n    width: 100%;\n    min-height: 100%;\n}\n\n.table_wrapper-overview{\n    width: 100%;\n    min-height: 100%;\n}\n.table_wrapper-overview th {\n    text-align: left;\n    padding-left: 1.3%;\n    height: 75px;\n    background-color: #DFDFEA;\n    font-size: 12px;\n    font-weight: 600;\n    color: #222222;\n}\n\n.table_wrapper.overview th:first-child {\n    border-radius: 5px 0 0 5px;\n}\n\n\n.table_wrapper th {\n    text-align: left;\n    height: 75px;\n    padding-left: 1.3%;\n    background-color: #DFDFEA;\n    font-size: 12px;\n    font-weight: 600;\n    color: #222222;\n}\n\n@media (max-width:450px){\n    .table_wrapper th {\n        text-align: left;\n        height: 75px;\n        padding-left: 3px;\n        background-color: #DFDFEA;\n        font-size: 12px;\n        font-weight: 600;\n        color: #222222;\n    }\n}\n\nth {\n    text-align: left;\n    padding: 0;\n    font-size: 12px;\n    background-color: #DFDFEA;\n    height: 76px;\n}\n\n.table_wrapper th:first-child {\n    border-radius: 5px 0 0 5px;\n}\n.table_wrapper th:last-child {\n    border-radius: 0 5px 5px 0;\n}\n.spacer {\n    height: 4px;\n}\n.table-item {\n    height: 74px;\n    background-color: #ffffff;\n}\n\n.dirty {\n    background-color: #F5C6CB;\n}\n\n.blocked_item {\n    height: 74px;\n    background-color: #EEEEF3;\n}\n\n.blocked_item > td {\n    color: #989898;\n}\n\n.permission_row {\n    border-bottom: 1px solid rgba(12,32,53,0.1);\n}\n\n.list-triangle {\n    position: relative;\n    z-index: 0;\n    font-size: 22px;\n    cursor: pointer;\n    margin-left: 10px;\n    color: #C3C4D1;\n}\n.list-triangle.top {\n    transform: rotateZ(-180deg) translateY(-10px);\n}\n.list-triangle.bottom {\n    transform: translateY(-10px);\n}\n.list-triangle.selected {\n    color: #000435;\n}\n/* PAGE TABLES FOR EMPLOYEES */\ntable.page-table td {\n    padding-left: 0px;\n}\ntable.page-table tr td:first-child {\n    padding-left: 10px;\n}\n\ntable.perm_table tr td {\n    border: solid 1px #F3F3F3;\n    border-style: none none solid none;\n    font-weight: 500;\n    color: #000000;\n    font-size: 12px;\n}\n\n\n/* ONLY ONE WAY TO DO BORDER-RADIUS */\ntable { border-collapse: separate; border-spacing: 0; }\ntd {\n    border: solid 1px #F3F3F3;\n    border-style: none solid solid none;\n    padding-left: 1.3%;\n    font-weight: 500;\n    color: #000000;\n    font-size: 12px;\n}\n\n.selected_row {\n    border: solid 1px rgba(116, 116, 147, 0.22);\n    border-style: none solid solid none;\n    border-top-style: solid;\n    padding-left: 25px;\n    font-weight: 500;\n    color: #000000;\n    font-size: 12px;\n    height: 74px;\n    background-color: rgba(118, 116, 147, 0.22);\n}\n\n\ntr td:first-child { border-bottom-left-radius: 5px; }\ntr td:last-child { border-bottom-right-radius: 5px; }\ntr td { border-top-style: solid; }\ntr td:first-child { border-left-style: solid; }\ntr td:not(:last-child) {border-right-style: hidden;}\n\n/* Employee without App STYLES */\n.employee_dot {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n}\n\ntd a {\n    text-decoration: none;\n    color: black;\n}\n\n.employee_table {\n    width: 100%;\n}\n@media (max-width: 700px) {\n    .employee_table {\n        table-layout: fixed;\n    }\n}\n/* Pending orders STYLES */\n.action_dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #A2ADBF;\n}\n.action_container {\n    cursor: pointer;\n    max-width: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    position: relative;\n}\n.action_dots_container {\n    position: relative;\n}\n.table_menu {\n    position: absolute;\n    min-width: 180px;\n    min-height: 30px;\n    background-color: white;\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    flex-direction: column;\n    right: 20px;\n    top: 15px;\n    z-index: 10!important;\n}\n.table_menu_item {\n    height: 3rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    position: relative;\n    padding-left: 10px;\n}\n.table_menu_item > p {\n    padding-left: 7px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #4B5960;\n}\n.table_menu_item > img {\n    width: 17px;\n    height: 17px;\n}\n.table_menu_item:not(:last-child) {\n    border-bottom: 1px solid rgba(112,112,112 ,0.1);\n}\n\n.table-status {\n    margin-top: 26px;\n    color: #747578;\n    font-size: 14px;\n}\n\n.notifications_list_item {\n    width: 100%;\n    height: 60px;\n    border-radius: 3px;\n    background-color: white;\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px;\n    min-width: 400px;\n}\n\n.unread_notification_dot {\n    width: 10px;\n    height: 10px;\n    min-width: 10px;\n    min-height: 10px;\n    border-radius: 50%;\n    background-color: red;\n    margin-right: 10px;\n}\n\n.notification_item_image_box {\n    position: relative;\n    height: 60px;\n    width: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.notification_item_image_box > img {\n    width: 80px;\n    margin-bottom: -10px;\n}\n\n.notification_item_name {\n    font-size: 14px;\n    padding-left: 10px;\n    font-weight: 600;\n    color: #1EC0A6;\n}\n\n.notification_item_text {\n    padding-left: 10px;\n    font-size: 12px;\n}\n\n.notification_item_date {\n    font-size: 12px;\n    color: #1EC0A6;\n}\n\n.notification_item_link {\n    width: 15px;\n    margin-left: 15px;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.notification_item_link:hover {\n    filter: sepia(100%) hue-rotate(190deg) saturate(500%) brightness(50%);\n}\n\n.billing_button {\n    padding: 3px 7px;\n    border: 1px solid #fd552b;\n    color: #fd552b;\n    border-radius: 5px;\n    font-size: 10px;\n}\n\n.billing_list_btn {\n    border: 1px solid #fd552b;\n    color: #fd552b;\n    padding: 5px 10px;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n@media (max-width: 1400px) {\n    .table_box {\n        width: 100%;\n        max-width: 86vw;\n        overflow-x: auto;\n    }\n    .responsive-mr-40 {\n        margin-right: 40px;\n    }\n    .notification_item_name {\n        font-size: 12px;\n        padding-left: 7px;\n    }\n    .notification_item_text {\n        padding-left: 7px;\n        font-size: 10px;\n    }\n    .notification_item_date {\n        font-size: 10px;\n        padding-left: 7px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
